// src/components/navigation/SiteFooter.jsx
import "../../styles/footer.css";

const SiteFooter = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer__inner">
        <div className="site-footer__brand">
          <span className="site-footer__eyebrow">Signal / Archive / Ritual</span>
          <h2 className="site-footer__title">Scrap Heap Archive</h2>
          <p className="site-footer__text">
            {/* Writings and reflections on esotericism, systems, history, culture, and politics. */}
          </p>
        </div>

        <div className="site-footer__meta">
          <span className="site-footer__pill">Transmission Active</span>
          <span className="site-footer__pill">Archive Indexed</span>
          <span className="site-footer__pill">Myth-System Online</span>
        </div>

        <div className="site-footer__sigil" />
      </div>

      <div className="site-footer__bottom">
        <span>© 2026 Scrap Heap</span>
        {/* <span>Built for thought, recursion, and strange crossings</span> */}
        <blockquote className="site-footer__quote">
            I said, "Kiss me, you're beautiful. These are truly the last days"
        </blockquote>
      </div>
    </footer>
  );
};

export default SiteFooter;